import { UserPlus } from 'lucide-react'
import { PersonaPortrait } from '../cells'
import type { SectionEditorProps } from './types'

interface Props extends SectionEditorProps<undefined> {}

/**
 * Read-only display of the linked persona for a story.
 *
 * Picking + linking is owned by the existing detail panel's meta strip. When
 * unlinked, this section still renders so the gap is visible and templated
 * (matching the Granola "missing required" pattern).
 */
export function LinkedPersonaSection({ requirement }: Props) {
  const fromLinks = requirement.personas[0]
  const fromMeta = typeof requirement.metadata?.linkedPersona === 'object'
    ? requirement.metadata.linkedPersona
    : null
  const persona = fromLinks ?? (fromMeta ? {
    name: fromMeta.name ?? '',
    role: fromMeta.role ?? '',
    photo: fromMeta.photo,
  } : null)

  if (!persona || !persona.name) {
    return (
      <div
        className="inline-flex items-center gap-2 px-2.5 py-1.5 rounded-md"
        style={{
          background: 'var(--color-warm-75, var(--color-warm-100))',
          border: '1px dashed var(--color-border-strong)',
          color: 'var(--color-fg-muted)',
          fontSize: 13,
        }}
      >
        <UserPlus size={12} />
        Link a persona — use the meta strip above
      </div>
    )
  }

  return (
    <div
      className="inline-flex items-center gap-2.5 px-2.5 py-1.5 rounded-md"
      style={{
        background: 'var(--color-warm-100)',
        border: '1px solid var(--color-border)',
      }}
    >
      <PersonaPortrait name={persona.name} photo={persona.photo} size={26} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-fg)', lineHeight: 1.2 }}>
          {persona.name}
        </div>
        {persona.role && (
          <div style={{ fontSize: 11.5, color: 'var(--color-fg-muted)', lineHeight: 1.2 }}>
            {persona.role}
          </div>
        )}
      </div>
    </div>
  )
}
